import ClassifiedTags from ".";

export const classifiedTagsRoutes = () => [
  {
    path: "/admin/classifieds-tags",
    component: ClassifiedTags,
    layout: "admin",
    routeType: "admin",
    title: "Classifieds Management",
  },
];
